export * from '@com/enums/user'

export enum ChannelReportPermission {
  Allow = 'allow', // 允许
  NoRange = 'no-range', // 未授权数据范围
  NoAdv = 'no-adv', // 无广告主
  NoAllowedPull = 'not-allowed-pull', // 不允许拉取
  NoData = 'no-data', // 无数据
}
